<div class="bcx-loader" role="status" aria-live="polite">
  <div class="bcx-loader-diagonal bcx-loader-diagonal-accent"></div>
  <div class="bcx-loader-diagonal bcx-loader-diagonal-main"></div>

  <div class="bcx-loader-content text-center">
    <div class="brand-logo bcx-loader-logo mx-auto mb-4" aria-hidden="true"></div>

    <h2 class="bcx-loader-headline mb-0">
      <span class="d-block bcx-loader-line-muted">STOP GUESSING.</span>
      <span class="d-block bcx-loader-line-bold">START SEEING.</span>
    </h2>

    <p class="bcx-loader-caption mt-3 mb-0">Loading your property intelligence</p>

    <div class="bcx-loader-dots mt-4" aria-hidden="true">
      <span></span><span></span><span></span>
    </div>

    <span class="visually-hidden">Loading, please wait…</span>
  </div>
</div>
